module.exports = __webpack_public_path__ + "img/login.3ed839d0.png";